"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RicercaLogDtoToJSON = exports.RicercaLogDtoFromJSONTyped = exports.RicercaLogDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function RicercaLogDtoFromJSON(json) {
    return RicercaLogDtoFromJSONTyped(json, false);
}
exports.RicercaLogDtoFromJSON = RicercaLogDtoFromJSON;
function RicercaLogDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dataInizio': !runtime_1.exists(json, 'dataInizio') ? undefined : (json['dataInizio'] === null ? null : new Date(json['dataInizio'])),
        'dataFine': !runtime_1.exists(json, 'dataFine') ? undefined : (json['dataFine'] === null ? null : new Date(json['dataFine'])),
        'pageSize': !runtime_1.exists(json, 'pageSize') ? undefined : json['pageSize'],
        'pageNumber': !runtime_1.exists(json, 'pageNumber') ? undefined : json['pageNumber'],
    };
}
exports.RicercaLogDtoFromJSONTyped = RicercaLogDtoFromJSONTyped;
function RicercaLogDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dataInizio': value.dataInizio === undefined ? undefined : (value.dataInizio === null ? null : value.dataInizio.toISOString()),
        'dataFine': value.dataFine === undefined ? undefined : (value.dataFine === null ? null : value.dataFine.toISOString()),
        'pageSize': value.pageSize,
        'pageNumber': value.pageNumber,
    };
}
exports.RicercaLogDtoToJSON = RicercaLogDtoToJSON;
